<div class="category" *ngIf="identityService.isCompanyAdmin()">
  <div class="form-row">
    <mat-form-field>
      <input
        matInput
        name="CategoryName"
        (input)="onChangeCategoryName($event)"
        (focus)="onChangeCategoryName($event)"
        [value]="finalCategoryName"
        [matAutocomplete]="auto"
        placeholder="{{ 'layers.form.Category.field' | translate }}"
      />
      <button
        mat-button
        matTooltip="{{ 'layers.form.Category.tooltip' | translate }}"
        *ngIf="finalCategoryName"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="onDeleteCategory()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </div>

  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onChooseCategoryFromAutocomplete($event)">
    <mat-option *ngFor="let category of filteredCategories" [value]="category">
      {{ category.Name }}
    </mat-option>
  </mat-autocomplete>
</div>
